import React from 'react';
import * as PropTypes from 'prop-types';

import Paper from '../Paper';
import Popup from '../common/Popup';
import CardIcon from '../common/CardIcon';
import styles from './styles.styl';

function InfoCardPopup({
  icon,
  title,
  onClose,
  isOpened,
  children,
  headerInfo,
  headerTitle,
  headerSubtitle,
  ...rest
}) {
  return (
    <Popup
      strictClose
      opened={isOpened}
      onClose={onClose}
      title={title}
      {...rest}
    >
      <Paper isLayoutColumn className="flex-grow-1">
        <div className={styles.header}>
          <CardIcon
            icon={icon}
            info={headerInfo}
            title={headerTitle}
            subtitle={headerSubtitle}
          />
        </div>
        {children}
      </Paper>
    </Popup>
  );
}

InfoCardPopup.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func,
  isOpened: PropTypes.bool,
  children: PropTypes.node,
  headerInfo: PropTypes.string,
  headerTitle: PropTypes.string,
  headerSubtitle: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

export default InfoCardPopup;



// WEBPACK FOOTER //
// ./src/components/InfoCardPopup/index.jsx